export default __webpack_public_path__ + "static/media/13.cf4f2cfe.png";